import {
  SUBSCRIPTION_REQUEST,
  SUBSCRIPTION_SUCCESS,
  SUBSCRIPTION_FAILURE,
  CANCEL_SUBSCRIPTION_ITEM_REQUEST,
  CANCEL_SUBSCRIPTION_ITEM_SUCCESS,
  CANCEL_SUBSCRIPTION_ITEM_FAILURE,
  CANCEL_SUBSCRIPTION_REQUEST,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CANCEL_SUBSCRIPTION_FAILURE,
} from '../actions/subscription'
import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'
import { PAY_NOW_SUCCESS } from '../actions/checkout'

const INITIAL_STATE = {
  isProcessing: false,
  isReady: false,
  isLoading: false,
  hasError: false,
  errorMessage: '',
  nextPayment: -1,
  price: '',
  items: [],
  status: '',
  merchant: '',
}

const subscriptionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case PAY_NOW_SUCCESS:
      return {
        ...INITIAL_STATE,
      }

    case SUBSCRIPTION_REQUEST:
      return {
        ...INITIAL_STATE,
        isLoading: true,
      }
    case SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isReady: true,
        isLoading: false,
        nextPayment: action.payload.nextPayment,
        price: action.payload.price,
        items: action.payload.items,
        status: action.payload.status,
        merchant: action.payload.merchant,
      }
    case SUBSCRIPTION_FAILURE:
      return {
        ...state,
        isReady: true,
        isLoading: false,
        hasError: true,
        errorMessage: action.payload.message,
      }

    case CANCEL_SUBSCRIPTION_ITEM_REQUEST:
    case CANCEL_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        isProcessing: true,
      }
    case CANCEL_SUBSCRIPTION_ITEM_FAILURE:
    case CANCEL_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        isProcessing: false,
        isReady: false,
      }
    case CANCEL_SUBSCRIPTION_ITEM_SUCCESS:
    case CANCEL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        isReady: false,
        nextPayment: -1,
        price: '',
        items: [],
        status: '',
      }
    default:
      return state
  }
}

export default subscriptionReducer
